<template>
  <error title="401" content="无权限访问该页面"></error>
</template>
<script>
import error from './error'
export default {
  name: "not-auth",
  components:{error}
};
</script>



// WEBPACK FOOTER //
// src/components/common/401.vue